import { useEffect, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useGetKiosk } from '../data-access';
import type { RootLoaderType } from '../data-access';
import { useTypedRouteLoaderData } from '../hooks';
import { useMenu, useModalsDisplayedContext } from '../providers';

export const Home = () => {
  const {
    kiosk: initialKiosk,
    kioskId,
    storeId,
  } = useTypedRouteLoaderData<RootLoaderType>('root');
  const { data: kiosk } = useGetKiosk({
    kioskId,
    initialData: initialKiosk,
  });
  const { visibleTabs, bannerMessage } = useMenu();

  const { commsBannerDisplayed, setCommsBannerDisplayed } =
    useModalsDisplayedContext();

  const location = useLocation();

  const showBanner = useMemo(
    () =>
      kiosk?.enable_comms_banner &&
      !!bannerMessage?.enabled &&
      !!bannerMessage?.is_expanded &&
      bannerMessage?.banner_type === 'text' &&
      !commsBannerDisplayed,
    [
      commsBannerDisplayed,
      bannerMessage?.enabled,
      bannerMessage?.is_expanded,
      bannerMessage?.banner_type,
      kiosk?.enable_comms_banner,
    ]
  );

  useEffect(() => {
    if (showBanner) {
      setCommsBannerDisplayed(true);
    }
  }, [showBanner, setCommsBannerDisplayed]);

  return (
    <Navigate
      to={`/stores/${storeId}/menu/${visibleTabs[0]}${
        showBanner ? '/comms-banner' : ''
      }`}
      state={location.state}
    />
  );
};
